import {
  Routes,
  Route,
  RoutesProps,
} from "react-router-dom";

import React, { Suspense } from "react";
import ProtectedRoute from "./ProtectedRoute";
import Main from "../components/Main";

import PublicRoute from "./PublicRoute";

const Navigation = () => {

  interface ProtectedRouteProps extends RoutesProps {
    authenticationPath: string;
  }
  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, "outlet"> = {
    authenticationPath: "/login",
  };

  const Login = React.lazy(() => import("../components/Login/Login"));
  const OtpSuccess = React.lazy(() => import("../components/Login/Success"));

  const Home = React.lazy(() => import("../pages/Home/Home"));
  const Menu = React.lazy(() => import("../pages/Menu/Menu"));
  const ItemList = React.lazy(() => import("../pages/ItemList/ItemList"));
  const Cart = React.lazy(() => import("../pages/Cart/Cart"));
  const CartSuccess = React.lazy(() => import("../pages/Cart/Success"));
  const Orders = React.lazy(() => import("../pages/Orders/Orders"));
  const OrderDetails = React.lazy(() => import("../pages/Orders/OrderDetails"));
  const Payment = React.lazy(() => import("../pages/Payment/Payment"));
  const PaymentDetails = React.lazy(() => import("../pages/Payment/PaymentDetails"));
  const SpillBill = React.lazy(() => import("../pages/Payment/SplittBill"));
  const Receipt = React.lazy(() => import("../pages/Payment/Receipt"));
  const EmailReceipt = React.lazy(() => import("../pages/Payment/EmailReceipt"));
  const EmailSuccess = React.lazy(() => import("../pages/Payment/EmailSuccess"));
  const AllOffer = React.lazy(() => import("../pages/Offers/AllOffer"));
  const PaymentMethod = React.lazy(() => import("../pages/Cart/PaymentMethod"));
  const OfferDetail = React.lazy(() => import("../pages/Offers/OfferDetails"));
  const QrDisplay = React.lazy(() => import("../pages/Payment/QrDisplay"));


  const WriteReview = React.lazy(() => import("../pages/Orders/WriteReview"));
  const Profile = React.lazy(() => import("../pages/Profile/Profile"));
  const Feedback = React.lazy(() => import("../pages/Profile/Feedback"));
  const Updates = React.lazy(() => import("../pages/Updates/Updates"));

  const Outlet = React.lazy(() => import("../components/Login/Outlets"));

  return (
    <>
      <div id="main-wraper">
        <Routes>
          <Route path="/login" element={
            <PublicRoute>
              <Suspense fallback={<></>}> <Login /> </Suspense>
            </PublicRoute>
          } />
          <Route path="/select-outlet" element={<Suspense fallback={<></>}> <Outlet /></Suspense>} />

          <Route index element={
            <PublicRoute>
              <Suspense fallback={<></>}> <Login /> </Suspense>
            </PublicRoute>
          } />
          <Route path="/otp-success" element={<Suspense fallback={<></>}> <OtpSuccess /> </Suspense>} />

          <Route path="/" element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<Main />} />}>
            <Route path="/home" element={<Suspense fallback={<></>}> <Home /> </Suspense>} />
            <Route path="/Menu" element={<Suspense fallback={<></>}> <Menu /> </Suspense>} />
            <Route path="/item-list" element={<Suspense fallback={<></>}> <ItemList /> </Suspense>} />
            <Route path="/cart" element={<Suspense fallback={<></>}> <Cart /> </Suspense>} />
            <Route path="/cart/success" element={<Suspense fallback={<></>}> <CartSuccess /> </Suspense>} />
            <Route path="/orders" element={<Suspense fallback={<></>}> <Orders /> </Suspense>} />
            <Route path="/order-details" element={<Suspense fallback={<></>}> <OrderDetails /> </Suspense>} />
            <Route path="/payment" element={<Suspense fallback={<></>}> <Payment /> </Suspense>} />
            <Route path="/payment-details" element={<Suspense fallback={<></>}> <PaymentDetails /> </Suspense>} />
            <Route path="/splitt-bill" element={<Suspense fallback={<></>}> <SpillBill /> </Suspense>} />
            <Route path="/receipt" element={<Suspense fallback={<></>}> <Receipt /> </Suspense>} />
            <Route path="/email-receipt" element={<Suspense fallback={<></>}> <EmailReceipt /> </Suspense>} />
            <Route path="/email-success" element={<Suspense fallback={<></>}> <EmailSuccess /> </Suspense>} />
            <Route path="/all-offers" element={<Suspense fallback={<></>}> <AllOffer /> </Suspense>} />

            <Route path="/payment-method" element={<Suspense fallback={<></>}> <PaymentMethod /> </Suspense>} />
            <Route path="/offer-details" element={<Suspense fallback={<></>}> <OfferDetail /> </Suspense>} />
            <Route path="/qr-display" element={<Suspense fallback={<></>}> <QrDisplay /> </Suspense>} />


            <Route path="/write-review" element={<Suspense fallback={<></>}> <WriteReview /> </Suspense>} />
            <Route path="/profile" element={<Suspense fallback={<></>}> <Profile /> </Suspense>} />
            <Route path="/feedback" element={<Suspense fallback={<></>}> <Feedback /> </Suspense>} />
            <Route path="/updates" element={<Suspense fallback={<></>}> <Updates /> </Suspense>} />

          </Route>
        </Routes >
      </div >
    </>
  );
};

export default Navigation;
